<div class=" mt-4">
     
    <section class="mt-3">
      <div class="">
        <div class="row">
          <div class="col-md-7">
            <div class="card-1">
              <div class="row">
                <div class="col-md-12">
                  
                  <div class="text-center">
                    <a class="view-h gary-t">PayOut Batch Details</a>
                  </div> 
  
                    <div class="row pt-5">
                        <div class=" col-md-12">
                            <div class="row mb-3">
                               <div class="col-4 p-0"> <label>Id</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"> {{Id}}</div>
                            </div>
                            <div class="row  mb-3">
                               <div class="col-4 p-0"> <label>Merchant Key Id</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"> {{MerchantKeyId }}</div>
                            </div>
                            <!-- <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Batch Number</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{BatchNumber}}</div></div> -->
                            <div class="row  mb-3">
                               <div class="col-4 p-0"> <label>Transaction Type</label> </div>
                                
                                <div class="col-7 p-0 view-text"> {{TransactionType}}</div>
                            </div>
                          
                            <div class="row  mb-3">
                                <div class="col-md-4  p-0"> <label>Total Transaction Count</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"><span class="sans-font">₹</span>  {{TotalTransactionCount}}</div>
                            </div>
                            <div class="row  mb-3">
                                <div class="col-md-4  p-0"> <label>Batch NetAmount</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"><span class="sans-font">₹</span>  {{BatchNetAmount}}</div>
                            </div>


                            <div class="row  mb-3">
                              <div class="col-md-4  p-0"> <label>Date Time</label> </div>
                              
                              <div class="col-7 p-0 view-text robot"><span class="sans-font">₹</span>  {{UpdatedDateTime| date:'d/M/yy, h:mm a'}}</div>
                          </div>


                            


                            <!-- <div class="row  mb-3">
                                <div class="col-md-4  p-0"> <label>BatchTime</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"><span class="sans-font">₹</span>  {{BatchTime | date:'d/M/yy, h:mm a'}}</div>
                            </div> -->
                            <!-- <div class="row  mb-3">
                                <div class="col-md-4  p-0"> <label>Batch Hash Amount</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"><span class="sans-font">₹</span>  {{BatchHashAmount}}</div>
                            </div>
                            <div class="row  mb-3">
                               <div class="col-4 p-0"> <label>Fee Amount </label> </div>
                                
                                <div class="col-7 p-0 view-text robot"><span class="sans-font">₹</span>  {{FeeAmount}}</div>
                            </div>
                            <div class="row  mb-3">
                                <div class="col-4 p-0"> <label>Gst Percentage </label> </div>
                                 
                                 <div class="col-7 p-0 view-text robot"> {{GSTPercentage}}</div>
                             </div>
                             <div class="row  mb-3">
                                <div class="col-4 p-0"> <label>Gst Amount </label> </div>
                                 
                                 <div class="col-7 p-0 view-text robot"> {{GSTAmount| currency:"₹"}}</div>
                             </div>
                             <div class="row  mb-3">
                                <div class="col-4 p-0"> <label>Additional Fee </label> </div>
                                 
                                 <div class="col-7 p-0 view-text robot"> {{AdditionalFee| currency:"₹"}}</div>
                             </div>
                             <div class="row  mb-3">
                                <div class="col-4 p-0"> <label>Total Fee Amount </label> </div>
                                 
                                 <div class="col-7 p-0 view-text robot"> {{TotalFeeAmount| currency:"₹"}}</div>
                             </div>
                            <div class="row  mb-3">
                               <div class="col-4 p-0"> <label>Net Settlement Amount</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"><span class="sans-font">₹</span>  {{NetSettlementAmount}}</div>
                            </div> -->
                            <!-- <div *ngIf="isSurchargeDetails">
                                <div class="row  mb-3">
                                    <div class="col-4 p-0"> <label>Surcharge FeeCode</label> </div>
                                     
                                     <div class="col-7 p-0 view-text robot"> {{responseFeeCode}}</div>
                                 </div>
                                <div class="row  mb-3">
                                    <div class="col-4 p-0"> <label>FeeDescription</label> </div>
                                     
                                     <div class="col-7 p-0 view-text robot"> {{responseFeeDescription}}</div>
                                 </div>
                                 <div class="row  mb-3">
                                    <div class="col-4 p-0"> <label>FeeType</label> </div>
                                     
                                     <div class="col-7 p-0 view-text robot"> {{responseFeeType}}</div>
                                 </div>
                                 <div class="row  mb-3">
                                    <div class="col-4 p-0"> <label>FeeValue</label> </div>
                                     
                                     <div class="col-7 p-0 view-text robot"> {{responseFeeValue}}</div>
                                 </div>

                            </div> -->

                            <!-- <div class="row  mb-3">
                               <div class="col-4 p-0"> <label>Batch Funding Reference No</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"> {{BatchFundingReferenceNo}}</div>
                            </div>


                                                               <div class="row  mb-3">
                               <div class="col-4 p-0"> <label>Batch Status</label> </div>
                                
                                <div class="col-7 p-0 view-text"> {{BatchStatus}}</div>
                            </div>
                                                                  <div class="row  mb-3">
                               <div class="col-4 p-0"> <label>Batch Date Time</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"> {{BatchDateTime}}</div>
                            </div> -->
                          
                        </div>
                    </div>  
                 
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="text-center">
              <img src="https://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout.png" class="w-100" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class=" mt-4"> 
           
            <div class="row">
                <div class="col-md-12">
                    <h4 class="poppins font-weight-bold pl-2">Transactions</h4>
                    <div class="float-right mb-3">
                        <button class="btn dash-btns" color="primary" id="btnExportBatch" (click)="readAndExportToExcelData()" >Download</button>
                    </div>
                </div>
                <div class="col-md-12 p-0">                  
                    <ngx-datatable #table class='bootstrap no-detail-row table-bordered' (columnMode)="'Force'" [footerHeight]="50" [scrollbarH]="true" [rowHeight]="'auto'"[columnMode]="'force'" [limit]="10" [rows]="rows" >
                        <ngx-datatable-column name="Action">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <a class="edit" [routerLink]="['/PayOut/PayOutBatchesViewdetails',{id : row.Id}]" data-toggle="tooltip" data-placement="top" title="View">
                                    <!-- [routerLink]="['/reports/viewsettledtransaction',{id : row.TransactionId,batchId:row.BatchId}]"> -->
                                    <img src="./assets/ViewDetails.svg">
                                </a>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="PayOut BatchId">
                            <ng-template let-row="row" ngx-datatable-cell-template><div class="robot font400">{{row.PayOutBatchId}} </div></ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column class="blue-bg" name="PayoutTransactionId">
                            <ng-template let-row="row" ngx-datatable-cell-template> <div class="robot font400">{{row.PayoutTransactionId }}</div> </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Payment Type">
                            <ng-template let-row="row" ngx-datatable-cell-template> {{row.PaymentType}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Transaction Type">
                            <ng-template let-row="row" ngx-datatable-cell-template> {{row.TransactionType}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Transaction Amount">
                            <ng-template let-row="row" ngx-datatable-cell-template><div class="text-right robot font400">₹{{row.TransactionAmount}}</div>
                            </ng-template>
                        </ngx-datatable-column>
                       <ngx-datatable-column name="Date Time">
                            <ng-template let-row="row" ngx-datatable-cell-template><div class="robot font400">{{row.RecordDateTime | date:'d/M/yy, h:mm a' }}</div></ng-template>
                        </ngx-datatable-column>
                        <!-- <ngx-datatable-column name="Batch Date Time">
                            <ng-template let-row="row" ngx-datatable-cell-template><div class="robot font400">{{row.BatchDateTime | date:'d/M/yy, h:mm a' }}</div></ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Batch Id">
                            <ng-template let-row="row" ngx-datatable-cell-template> <div class="robot font400">{{row.BatchId}}</div> </ng-template>
                        </ngx-datatable-column> -->
                    </ngx-datatable>
                </div>
            </div>
       
    </div>
    </section>
  </div>










 





























<!-- <div fxLayout="column">
          <table class="my-table">
              <tbody>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Id</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{Id}}</div></div>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>MerchantKeyId</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{MerchantKeyId }}</div></div> -->
<!-- <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Batch Number</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{BatchNumber}}</div></div> -->
<!-- <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Payment Type</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{PaymentType}}</div></div> -->
<!-- <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Credit Transaction Count </label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{CreditTransactionCount}}</div></div>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Sale Transaction Count</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{SaleTransactionCount}}</div></div>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Total Transaction Count</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{TotalTransactionCount}}</div></div> -->

<!-- <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Sale Amount</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{SaleAmount}}</div></div>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Credit Amount</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{CreditAmount }}</div></div>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Batch Net Amount</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{BatchNetAmount}}</div></div>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Batch Hash Amount</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{BatchHashAmount}}</div></div>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Fee Amount </label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{FeeAmount}}</div></div>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Net Settlement Amount</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{NetSettlementAmount}}</div></div>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Batch Funding Reference No</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{BatchFundingReferenceNo}}</div></div> -->


<!-- <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>User name</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{UserName }}</div></div> -->
<!-- <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Batch Status</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{BatchStatus}}</div></div> -->
<!-- <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Batch Response</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{BatchResponse}}</div></div>
                  <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Batch Response Code</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{BatchResponseCode}}</div></div> -->
<!-- <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Batch Date Time</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{BatchDateTime}}</div></div> -->
<!-- <div class="row  mb-3"><div class="col-7 p-0 view-text"> <label>Last Updated Date</label> </div><div class="col-7 p-0 view-text">:</div><div class="col-7 p-0 view-text"> {{UpdatedDateTime}}</div></div> -->

<!-- 
              </tbody>
          </table>

  </div>
</div> 
 
 <div class="break"></div>
  
  <div fxLayout="row" fxLayout.md="row"  fxLayoutAlign="space-evenly stretch" fxLayoutGap="20px"  fxFlex="90"
  fxFlexOffset="5" fxFlex.md="90" fxFlexOffset.md="5" fxFlex.gt-lg="70" fxFlexOffset.gt-lg="15" fxFlex.xs="100" fxFlexOffset.xs="0" class="home-promotion  p-20" >
  <div class=" m-b-0"  fxFlex="100"> -->
<!-- <div fxLayout="column">
          <table #table [dataSource]="AlldataSource" matSort>
              <ng-container matColumnDef="actions">
                <mat-header-cell class="actions-cell" *matHeaderCellDef mat-sort-header></mat-header-cell>
                <mat-cell class="actions-cell" *matCellDef="let row">
                  <button id="viewTransaction" [routerLink]="['/home/transaction/view-transaction',{id : row.Id}]" >
                    <span matTooltip="View" matTooltipPosition="above">View</span>
                  </button>
                </mat-cell>
              </ng-container>
         
              <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.isModelProperty" [matColumnDef]="column.property">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.name }}</mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{ row[column.property] }}</mat-cell>
                </ng-container>
              </ng-container>
              <mat-header-row *matHeaderRowDef="visibleColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: visibleColumns;"></mat-row>
            </table>

       -->
<!-- <div class="m-b-0" fxFlex="100">
        <table #table [dataSource]="AlldataSource" matSort>
          <ng-container matColumnDef="actions">
            <mat-header-cell class="actions-cell" *matHeaderCellDef mat-sort-header></mat-header-cell>
            <mat-cell class="actions-cell" *matCellDef="let row">
              <button id="viewTransaction"  color="primary" [routerLink]="['/home/reports/view-settled-transaction',{id : row.Id,batchId:row.BatchId}]">
                <span matTooltip="View" matTooltipPosition="above">View</span>
              </button>
            </mat-cell>
          </ng-container>
          
          <ng-container *ngFor="let column of columns">
            <ng-container *ngIf="column.isModelProperty" [matColumnDef]="column.property">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.name }}</mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row[column.property] }}</mat-cell>
            </ng-container>
          </ng-container>
          <mat-header-row *matHeaderRowDef="visibleColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: visibleColumns;"></mat-row>
        </table>
  
    
  
      
  </div> -->

<!-- </div>
</div> -->